import { render } from "./recentTeamingWin.vue?vue&type=template&id=4ac8bd4d"
import script from "./recentTeamingWin.vue?vue&type=script&lang=js"
export * from "./recentTeamingWin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__